import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import '../style/PetList.css'; // Import the CSS file

const PetList = ({ orgId: propOrgId }) => {
    const { orgId: paramOrgId } = useParams();
    const orgId = propOrgId || paramOrgId;
    const [pets, setPets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        console.log('Current Language:', i18n.language);
        const fetchPets = async () => {
            try {
                setLoading(true);
                setError(null);

                const storedUser = JSON.parse(localStorage.getItem('user'));
                const token = storedUser?.token;

                if (!token) {
                    throw new Error('No authentication token found');
                }

                console.log('Organization ID:', orgId);

                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/organizations/${orgId}/pets`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('Fetched Pets:', response.data);
                setPets(response.data);
            } catch (err) {
                console.error('Error fetching pets:', err.response || err.message);
                setError(err.response?.data?.error || 'Failed to fetch pets');
            } finally {
                setLoading(false);
            }
        };

        if (orgId) {
            fetchPets();
        }
    }, [orgId]);

    if (loading) return <p className="text-dafauna-darkText">{t('petList.loading')}</p>;
    if (error) return <p className="text-dafauna-darkText">{t('petList.error', { error })}</p>;

    return (
        <div className='pet-list'>
            <div className="title-container">
                <h2 className="text-lg text-dafauna-darkText">{t('petList.title')}</h2>
                <Link
                    to={`/organizations/${orgId}/members`}
                    className="view-members-icon bg-dafauna-primary text-white hover:bg-dafauna-primaryLight"
                >
                    <FaUsers />
                </Link>
            </div>
            <div className="pet-list-container">
                {pets.map((pet) => {
                    const profileImage = pet.images?.find((image) => image.tag === 'profile')?.url || pet.images?.[0]?.url;
                    return (
                        <Link to={`/pet/${pet._id}`} className="pet-card shadow-md hover:shadow-lg" key={pet._id}>
                            {profileImage ? (
                                <img src={profileImage} alt={pet.name || t('generalPet.imageAvailable')} className="rounded-xl" />
                            ) : (
                                <div className="placeholder-image">{t('generalPet.imageAvailable')}</div>
                            )}
                            <h3 className="text-dafauna-darkText mt-1">{pet.name || 'Unnamed Pet'}</h3>
                        </Link>
                    );
                })}
                <div
                    className="add-pet-card bg-dafauna-background hover:bg-dafauna-primaryLight"
                    onClick={() => navigate(`/create-pet?orgId=${orgId}`)}
                >
                    <span className="text-dafauna-gray">{t('petList.addPet')}</span>  
                </div>
            </div>
        </div>
    );
};

export default PetList;